require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-vogue-living-grange-residence.json") })
        }
      }, "path---journal-vogue-living-grange-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-vogue-living-grange-residence!./.cache/json/journal-vogue-living-grange-residence.json
// module id = 554
// module chunks = 231608221292675